export enum CookieVariation {
    Control = 0,
    PlusSayan = 1,
    SayanReplacing = 2,
    LEBI = 3,
}
